import type { CustomizeGridContent } from "../types";

export const customizeGrid: CustomizeGridContent = {
  title: "Bygget til følsomme forskningsdata.",
  lead:
    "De kontrolmekanismer, som gjorde UCloud til den nationale platform for " +
    "følsomme forskningsdata, omfatter nu også hvert inferenskald.",
  cards: [
    {
      title: "Styring som standard",
      body: "ISO/IEC 27001:2022-certificeret og godkendt til følsomme data. Projektroller, kvoter og adgang forbliver under din og dit universitets kontrol.",
    },
    {
      title: "Forskningsfiler, forbundet",
      body: "Kør modeller direkte mod de data, der allerede ligger i dit UCloud-projekt. Datasæt, transskriptioner og dokumenter forlader aldrig projektet for at nå en model.",
    },
    {
      title: "Dansk opbevaring, som standard",
      body: "Dine data forbliver i Danmark og bruges aldrig til modeltræning, uanset hvilken model. Hver forespørgsel behandles på national infrastruktur under dansk lovgivning.",
    },
  ],
};
